import { render, staticRenderFns } from "./showPreviewPage.vue?vue&type=template&id=2dc7b38a&"
import script from "./showPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./showPreviewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports